import { Box, Group, Paper, Stack, Text } from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

import { messages } from './messages';
import { ShipmentLimitProgress } from './shipment-limit-progress';
import styles from './usage-summary.module.css';

type UsageSummaryProps = {
  planName: string;
  shipmentLimit: number;
  totalUsage: number;
  isAtLimit: boolean;
  isHighLimitWarning: boolean;
  isMediumLimitWarning: boolean;
};

export const UsageSummary = ({
  planName,
  shipmentLimit,
  totalUsage,
  isAtLimit,
  isHighLimitWarning,
  isMediumLimitWarning,
}: UsageSummaryProps) => {
  const intl = useIntl();

  return (
    <Paper className={styles.container} p='sm' withBorder>
      <Stack gap={0}>
        <Text fw={600} size='sm'>
          {planName}
        </Text>
        <Group gap={4}>
          <Text c='dimmed' size='sm'>
            <FormattedMessage {...messages.shipmentsPerMonth} values={{ shipmentLimit: intl.formatNumber(shipmentLimit) }} />
          </Text>
        </Group>
      </Stack>
      <Box mt='sm'>
        <ShipmentLimitProgress
          isHighLimitWarning={isHighLimitWarning}
          isMediumLimitWarning={isMediumLimitWarning}
          isAtLimit={isAtLimit}
          shipmentLimit={shipmentLimit}
          totalUsage={totalUsage}
        />
      </Box>
    </Paper>
  );
};
